module.exports = __webpack_public_path__ + "static/media/np.56bce84c.svg";